export const BREAD_CRUMB_COTTAGE_RENTAL = 'Cottage rental'
export const BREAD_CRUMB_CHALETS_A_LOUER = 'Chalets à louer'
